/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
const commonUtils = {
  getSiblings: (elem: HTMLElement): HTMLElement[] => {
    const siblings: HTMLElement[] = []
    let sibling = elem?.parentNode?.firstChild as HTMLElement
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== elem) {
        siblings.push(sibling)
      }
      sibling = sibling.nextSibling as HTMLElement
    }
    return siblings
  },

  hexTorgb: (hex: string, opacity: number): string | undefined => {
    const h = hex.replace('#', '')
    const hh = h.match(new RegExp(`(.{${h.length / 3}})`, 'g'))
    const rgba: number[] = []
    if (!hh) return
    for (let i = 0; i < hh.length; i += 1)
      rgba[i] = parseInt(hh[i].length === 1 ? hh[i] + hh[i] : hh[i], 16)

    if (typeof opacity !== 'undefined') rgba.push(opacity)

    return `rgba(${rgba.join(',')})`
  },

  flatDeep: (arr: any[], d = 1): any[] => {
    return d > 0
      ? arr.reduce((acc, val) => {
          return acc.concat(
            Array.isArray(val) ? commonUtils.flatDeep(val, d - 1) : val,
          ) as any[]
        }, [])
      : arr.slice()
  },

  hasKey: (obj: any, key: string): boolean => {
    return !!Object.prototype.hasOwnProperty.call(obj, key)
  },

  generateDayWiseTimeSeries: (
    baseval: number,
    count: number,
    yrange: { min: any; max: any },
  ) => {
    let i = 0
    let value = baseval
    const series: [number, number][] = []
    while (i < count) {
      const y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min

      series.push([value, y])
      value += 86400000
      i += 1
    }
    return series
  },

  formatDate: (dateString: string, isDetail = false) => {
    if (!dateString || dateString === null) return ''

    let date: Date

    const isCustomFormat = /^\d{14}$/.test(dateString)
    if (isCustomFormat) {
      const formattedDateString = dateString.replace(
        /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/,
        '$1-$2-$3T$4:$5:$6',
      )
      date = new Date(formattedDateString)
    } else if(dateString.length == 8){
      // YYYYMMDD 형식
      return `${dateString.substring(0,4)}.${dateString.substring(4,6)}.${dateString.substring(6,8)}`;
    } else {
      date = new Date(dateString)
    }

    if (isNaN(date.getTime())) return ''

    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')

    const now = new Date()
    const isToday =
      year === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      day === now.getDate().toString().padStart(2, '0')

    // 상세(detail) 페이지일 경우 항상 yyyy.MM.dd hh:mm:ss 형식
    if (isDetail) {
      return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`
    }

    // 오늘 날짜인 경우 시분초만 출력
    if (isToday) {
      return `${hours}:${minutes}:${seconds}`
    }

    // 오늘이 아니면 날짜만 출력
    return `${year}.${month}.${day}`
  },

  isYYYYMMDD: (dateStr:string)=>{
    // 숫자만 남기고 제거 (YYYYMMDD, YYYY.MM.DD, YYYY/MM/DD 등 어떤 형식이든 대응)
    const digits = dateStr.replace(/\D/g, "");

    if (digits.length !== 8) return false; // YYYYMMDD 형식이 안되면 무효

    const year = Number(digits.substring(0, 4));
    const month = Number(digits.substring(4, 6));
    const day = Number(digits.substring(6, 8));

    // 월(1~12)과 일(1~31) 범위 체크
    if (month < 1 || month > 12 || day < 1 || day > 31) return false;

    // Date 객체를 활용한 유효성 검사
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  },

  dateStrChgFomat: (dateString: string, format: string) => {
    if (!dateString || dateString === null) return ''

    let date: Date

    const isYYYYMMDDHHmmss = /^\d{14}$/.test(dateString);
    const isYYYYMMDD = commonUtils.isYYYYMMDD(dateString);
    if (isYYYYMMDDHHmmss) {
      const formattedDateString = dateString.replace(
        /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/,
        '$1-$2-$3T$4:$5:$6',
      )
      date = new Date(formattedDateString)
    } else if(isYYYYMMDD) {
      const formattedDateString = dateString.replace(
        /^(\d{4})(\d{2})(\d{2})$/,
        '$1-$2-$3',
      )
      date = new Date(formattedDateString)
    } else {
      date = new Date(dateString)
    }

    if (!(date instanceof Date) || isNaN(date.getTime())) {
        console.error('Invalid Date ['+dateString+']');
        return dateString;
    }

    const pad = (n: number) => n.toString().padStart(2, '0');

    const replacements: Record<string, string> = {
        yyyy: date.getFullYear().toString(),
        MM: pad(date.getMonth() + 1),
        dd: pad(date.getDate()),
        HH: pad(date.getHours()),
        mm: pad(date.getMinutes()),
        ss: pad(date.getSeconds()),
    };

    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, token => replacements[token]);
  }
}

export default commonUtils
